module.exports = __webpack_public_path__ + "img/ils.36eaae46.svg";